// Phase 4 Task 10 — Preview a selected logo before submitting the form.
// Reads the file via FileReader, sets the preview <img> src, and dims the
// "current logo" element since the user is replacing it. Server-side
// active_storage_validations (PNG/JPG/SVG, 2MB) remains the source of truth.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "preview", "currentImage"];

  preview(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      this.previewTarget.src = e.target.result;
      this.previewTarget.hidden = false;
      if (this.hasCurrentImageTarget) {
        this.currentImageTarget.style.opacity = "0.4";
      }
    };
    reader.readAsDataURL(file);
  }
}
